module.exports = __webpack_public_path__ + "img/mobile/Background-freespins/fsbackground-portrait-wide@3x.jpg?1.0.24";


//////////////////
// WEBPACK FOOTER
// ./out/img/mobile/Background-freespins/fsbackground-portrait-wide@3x.jpg
// module id = 177
// module chunks = 0